<p-dialog header="Template" [(visible)]="showTemplateDialog" [responsive]="true" [modal]="true" [dismissableMask]="true" [style]="DialogStyle40" class="save-dialog"
          [contentStyle]="{'min-height':'300px'}">
  <form #dialogForm="ngForm">
    <div>
      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-lg-2">
          <label for="templateName" required>Name</label>
        </div>

        <div class="p-col-12 p-md-10 p-lg-10">

          <p-dropdown  *ngIf="loadDialog" [options]="templateOptions" [(ngModel)]="selectedTemplate" name="selectedTemplate"  [filter]="true" [showClear]="true" placeholder="Select..."></p-dropdown>
          <input *ngIf="!loadDialog" type="text" pInputText [(ngModel)]="templateName" placeholder="Please type name of the template to save" name="template" required #name="ngModel" />
        </div>
      </div>
    </div>
    <p-footer>
      <div style="position: absolute;bottom:10px;right:10px;">
        <button type="button" pButton icon="fa fa-close" class="button-inaction" (click)="cancel()" label="Cancel"></button>
        <button type="button" pButton icon="fa fa-close" class="button-action" (click)="deleteTemplate()" label="Delete" *ngIf="loadDialog" [disabled]="!dialogForm.form.valid"></button>
        <button type="button" pButton icon="fa fa-check" class="button-action" (click)="emitTemplate()" label="Load" *ngIf="loadDialog" [disabled]="!dialogForm.form.valid"></button>
        <button type="button" pButton icon="fa fa-check" class="button-action" (click)="saveTemplate(templateName)" label="Save" *ngIf="!loadDialog" [disabled]="!dialogForm.form.valid"></button>
      </div>
    </p-footer>
  </form>
</p-dialog>
